import { useTheme } from '@mui/material'
import { styled } from '@mui/material/styles'
import { Chart } from 'react-chartjs-2'
import { ChartData, ChartOptions } from 'chart.js'
import 'chart.js/auto'
import 'chartjs-adapter-date-fns'
import fi from 'date-fns/locale/fi'
import merge from 'lodash/merge'

export interface LineChartProps {
  data: ChartData
  options: ChartOptions
  wrapperHeight?: string | number
}

export default function LineChart({ data, options, wrapperHeight = '280px' }: LineChartProps) {
  const theme = useTheme()

  const LineChartWrapper = styled('div')`
    height: ${wrapperHeight};
  `

  const defaultOptions: ChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    animation: false,
    normalized: true,
    locale: 'fi-FI',
    font: {
      family: "'Inter', sans-serif"
    },
    interaction: {
      mode: 'index',
      axis: 'x',
      intersect: false
    },
    plugins: {
      title: {
        display: true,
        position: 'bottom',
        padding: {
          top: 24
        },
        font: {
          // @ts-expect-error typed incorrectly
          weight: '600',
          size: 14
        },
        color: theme.palette.text.primary
      },
      legend: {
        display: true,
        labels: {
          boxWidth: 24,
          boxHeight: 1,
          padding: 24,
          font: {
            family: "'Inter', sans-serif",
            // @ts-expect-error typed incorrectly
            weight: '400',
            size: 12
          }
        }
      },
      decimation: {
        enabled: false,
        algorithm: 'min-max'
      }
    },
    elements: {
      point: {
        pointStyle: 'point',
        radius: 0
      },
      line: {
        borderWidth: 1,
        spanGaps: false
      }
    },
    scales: {
      x: {
        display: true,
        adapters: {
          date: {
            locale: fi
          }
        },
        ticks: {
          source: 'auto',
          autoSkip: true,
          maxRotation: 0
        },
        grid: {
          display: true,
          color:
            theme.palette.mode === 'light'
              ? 'rgba(0, 0, 0, 0.0375)'
              : 'rgba(255, 255, 255, 0.0375)',
          // @ts-expect-error typed incorrectly
          fontColor: '#fff',
          drawBorder: false
        },
        color: '#fff'
      },
      y: {
        display: true,
        grid: {
          display: true,
          color:
            theme.palette.mode === 'light'
              ? 'rgba(0, 0, 0, 0.0375)'
              : 'rgba(255, 255, 255, 0.0375)',
          // @ts-expect-error typed incorrectly
          fontColor: '#fff',
          drawBorder: false
        }
      }
    }
  }

  options = merge(defaultOptions, options)

  return (
    <LineChartWrapper>
      <Chart redraw type="line" data={data} options={options} />
    </LineChartWrapper>
  )
}
